import React from 'react';
import { flowchartRows } from '../data/tables';
const toneStyles: Record<string, string> = {
  green: 'text-flag-green',
  amber: 'text-flag-amber',
  red: 'text-flag-red',
  neutral: 'text-ink-soft'
};
export function FlowchartCard() {
  return <figure className="mx-auto mt-10 max-w-3xl" data-id="element-100" data-mp="2z0th5mbyq7ab">
      <div className="overflow-hidden rounded-2xl border border-sage/15 bg-white shadow-page" data-id="element-101" data-mp="2u3jv8gns8dr8">
        <div className="flex items-center justify-between border-b border-sage/15 px-5 py-3.5 sm:px-8" data-id="element-102" data-mp="390am21je4h58">
          <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.14em] text-brass" data-id="element-103" data-mp="342sm30ncpc9d">
            Vol. 1 — The Screening System
          </p>
          <p className="font-sans text-[11px] text-ink-muted" data-id="element-104" data-mp="3hv8gjd26s1yo">Master flowchart</p>
        </div>

        <div className="overflow-x-auto px-5 py-6 sm:px-8 sm:py-8" data-id="element-105" data-mp="3du6g4swj9jv4">
          <table className="w-full min-w-[520px] border-collapse text-left" data-id="element-106" data-mp="3rs3f1vygm2cy">
            <caption className="sr-only" data-id="element-107" data-mp="3mtjrxs84qkj0">
              The 90-Second Screen master flowchart: three questions, their answers, and the
              resulting decision.
            </caption>
            <thead data-id="element-108" data-mp="2swzydzmk75sm">
              <tr className="bg-sage text-white" data-id="element-109" data-mp="2syku3skm0us2">
                <th scope="col" className="rounded-l-lg px-4 py-2.5 font-sans text-[11px] font-semibold uppercase tracking-[0.12em]" data-id="element-110" data-mp="2xww36132z198">
                  Question
                </th>
                <th scope="col" className="px-4 py-2.5 font-sans text-[11px] font-semibold uppercase tracking-[0.12em]" data-id="element-111" data-mp="31wdbr3dt0eim">
                  Answer
                </th>
                <th scope="col" className="rounded-r-lg px-4 py-2.5 font-sans text-[11px] font-semibold uppercase tracking-[0.12em]" data-id="element-112" data-mp="3bvciggf0e02z">
                  Output
                </th>
              </tr>
            </thead>
            <tbody data-id="element-113" data-mp="3llnn656iodax">
              {flowchartRows.map((row, index) => <tr key={`${row.answer}-${index}`} className="border-b border-sage/10 last:border-0" data-id="element-114" data-mp="3ppdakrbggoud" data-mpi={index}>
                  <th scope="row" className="w-[38%] px-4 py-3.5 align-top font-sans text-[13px] font-semibold leading-snug text-ink" data-id="element-115" data-mp="3unwzn0lcigqy">
                    {row.question}
                  </th>
                  <td className="px-4 py-3.5 align-top font-sans text-[13px] leading-snug text-ink-soft" data-id="element-116" data-mp="24ap24t5qydh8">
                    {row.answer}
                  </td>
                  <td className={`px-4 py-3.5 align-top font-sans text-[13px] font-semibold leading-snug ${toneStyles[row.tone]}`} data-id="element-117" data-mp="1zintribp96wh">
                    {row.output}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      <figcaption className="mx-auto mt-5 max-w-2xl text-center font-sans text-[14px] leading-[1.6] text-ink-muted" data-id="element-118" data-mp="2ia85z9riz2nq">
        You don't need the client's diagnosis. You screen the situation, not the condition — which
        is exactly what keeps you inside your professional scope.
      </figcaption>
    </figure>;
}